import { Switch } from 'antd';

/** On/off switch (Ant Switch) replacing the legacy .toggle-switch markup; the aria-label is what tests and screen readers use. */
export function Toggle({ checked, onChange, label, disabled, id }: { checked: boolean; onChange: (next: boolean) => void; label: string; disabled?: boolean; id?: string }) {
  return <Switch id={id} checked={checked} disabled={disabled} aria-label={label} onChange={(v) => onChange(v)} />;
}
